import React from 'react';
import {useNavigate,useSearchParams} from 'react-router-dom';
import {PaperProvider} from 'react-native-paper';
import SafetyCenter from '../../components/SafetyCenter';
export default function SafetyPage(){
 const navigate=useNavigate();const [params]=useSearchParams();
 return <PaperProvider><SafetyCenter initialLocation={params.get('location')||''} onBack={()=>navigate(-1)}/></PaperProvider>;
}
